<template>
    <ListItem :danger="danger">
        <button
            type="button"
            :disabled="disabled"
            :aria-label="ariaLabel"
            :aria-expanded="ariaExpanded"
            :aria-haspopup="ariaHaspopup"
            class="flex w-full items-center gap-2 rounded focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2"
            :class="danger ? 'text-theme-danger' : 'text-theme-text'"
            @click="emitClick"
        >
            <svg-icon
                v-if="iconName"
                class="mt-0.5"
                :icon-class="danger ? 'text-theme-danger' : 'text-theme-icon'"
                :fill="iconCustomFill"
                :icon="iconName"
                width="20px"
                height="20px"
            />
            <slot />
        </button>
    </ListItem>
</template>
<script>
import ListItem from './ListItem.vue';

export default {
    components: {
        ListItem,
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconName: {
            type: String,
            required: false,
            default: null,
        },
        iconCustomFill: {
            type: String,
            default: null,
        },
        ariaExpanded: {
            type: Boolean,
            default: null,
        },
        ariaHaspopup: {
            type: String,
            default: null,
        },
        ariaLabel: {
            type: String,
            default: null,
        },
        /** An item that deletes: red text and icon, over a red hover. */
        danger: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
    methods: {
        emitClick() {
            this.$emit('click');
        },
    },
};
</script>
